<br />
<div   *ngIf="!visible">
  <div class="form-row">
    <div class="form-group col-md-24">
      <h1 for="inventors">Verilere Vekil Kaydı Ekle</h1>

      <br />
      <div class="form-group col-md-8" id="inventors">
        <div class="form-group col-md-3" >
          <div >
            <input [(ngModel)]="attorneyName" placeholder="Vekil Adı"

            (ngModelChange)="attorneyName = $event.toLowerCase()"
            type="text"
            id="attorneyName"/>
          </div>
        </div>

        <div class="form-group col-md-3" >
          <div >
            <input
            [(ngModel)]="attorneyAdress"
            (ngModelChange)="attorneyAdress = $event.toLowerCase()"
              placeholder="Vekilin Adresi"
            />
          </div>
        </div>

        <div class="form-group col-md-3" >

            <input
            [(ngModel)]="attorneyId"
              placeholder="Vekil Kayıt No."
              (ngModelChange)="attorneyId = $event.toLowerCase()"
            />
          </div>
        </div>
        <div id="inventors">
          <div>
            <button
              (click)="submit()"
              class="btn"

              style="
                margin-left: auto;
                margin-right: 20%;
                font-size: 18px;
                display: block;
                height: fit-content;
              "
            >
              Vekil Bilgilerini Kaydet
            </button>
          </div>
        </div>
      </div>


    </div>

</div>

<h2 *ngIf="!error">{{ record }}</h2>
<h2 *ngIf="error">
  {{ error }} . Lütfen kayıt bilgilerinizi ve internetinizi kontrol ediniz.
</h2>
<br />

<button
  type="button"
  class="btn btn-warning"
  style="background-color: #d70040"
  (click)="findAttorney()"
>
  {{
    visible
      ? "Kayıtlı Vekil Bilgilerini Gizle"
      : "Kayıtlı Vekil Bilgilerini Listele"
  }}
</button>

<h2 style="margin-left: 2%" *ngIf="visible && !error">
  Kayıtlı Vekil Sahipleri
</h2>
<h2 *ngIf="error">
  {{ error }} . Lütfen kayıt bilgilerinizi ve internetinizi kontrol ediniz.
</h2>
<input
  *ngIf="visible && !error"
  class="form-control"
  type="text"
  name="search"
  class="icon"
  [(ngModel)]="searchText"
  (ngModelChange)="searchText = $event.toLowerCase()"

  autocomplete="off"
  placeholder="Vekil Bilgileri Üzerinden Arama Yap"
  id="input1"
/>

<table *ngIf="visible && !error">
  <thead>
    <th>#</th>
    <th>Vekil Adı</th>
    <th>Vekil Adresi</th>
    <th>Vekil No.</th>
    <th>Kaydı oluşturan ve kayıt tarihi</th>
  </thead>
  <tbody>
    <tr *ngFor="let user of users; let i = index">
      <ng-container *ngFor="let item of user | filter: searchText">
        <td>{{ i + 1 }}</td>
        <td>{{ item.AttorneyName }}</td>
        <td>{{ item.AttorneyAdress }}</td>
        <td>{{ item.AttorneyIdentityNo }}</td>

        <td>
          Kaydı Yapan:{{ item.LoggedUser[0].recordingUser }}
          <p>Kayıt Tarihi:{{ item.LoggedUser[0].date | date: "dd/MM/yyyy" }}</p>
        </td>
        <td style="background-color: #f8f9fb">
          <button
            type="button"
            id="add"
            class="btn btn-primary"
            style="background-color: #d70040"
            (click)="removeAttorney(i)"
          >
            Vekil kaydını sil
          </button>
        </td>
      </ng-container>
    </tr>
  </tbody>
</table>
